import { X } from 'lucide-react';

import { getFileNameFromUrl } from '#/utils/helperFunctions';

function RenderFileList({ files, fieldName, handleRemoveFile }) {
  if (!files) return null;

  return (
    <div className="file-wrapper">
      {files?.map((file, i) => (
        <div key={i} className="file-name">
          <span>{getFileNameFromUrl(file).slice(0, 24)}</span>
          <button className="cross-icon" onClick={handleRemoveFile(fieldName, file)}>
            <X />
          </button>
        </div>
      ))}
    </div>
  );
}

export default RenderFileList;
